<script>
  import { onMount } from "svelte"
  import { Layout } from "../components"
  import { baseUrl, getOpenApiDefinition } from "../services/endpoints"
  import SwaggerUI from 'swagger-ui'
  import 'swagger-ui/dist/swagger-ui.css';

  onMount(() => {
    getOpenApiDefinition().then(resp => {
      resp["servers"] = [{
        "url": baseUrl("").toString().replace("/api/v1", "")
      }]
      SwaggerUI({
        dom_id: '#swagger',
        spec: resp
      })
    })
  })
</script>

<Layout selected="openapi">
  <div id="swagger"></div>
</Layout>
